import { render, staticRenderFns } from "./ForReviewEmployees.vue?vue&type=template&id=5d494229&scoped=true"
import script from "./ForReviewEmployees.vue?vue&type=script&lang=js"
export * from "./ForReviewEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d494229",
  null
  
)

export default component.exports